import React, { useEffect, useState } from 'react'

const ForPartnersMessage = ({ register, messageValue, setValue }) => {
    const [isFocused, setIsFocused] = useState<boolean>(false)
    const [screenWidth, setScreenWidth] = useState(1200)
    const [letters, setLetters] = useState(0)


    const handleTextareaResize = (event) => {
        const textarea = event.target;
        setValue(textarea.value)
        textarea.style.height = 'auto';
        textarea.style.height = `${textarea.scrollHeight}px`;
    };

    useEffect(() => {
        const lettersAmount = () => {
            if (screenWidth <= 1000) {
                return 15
            }
            if (screenWidth <= 1250) {
                return 18
            }
            return 20
        }

    }, [isFocused])

    useEffect(() => {
        const lettersAmount = () => {
            if (screenWidth <= 1000) {
                return 15
            }
            if (screenWidth <= 1250) {
                return 18
            }
            return 20
        }

        const updateScreenWidth = () => {
            setScreenWidth(window.innerWidth)
            setLetters(lettersAmount())
        }

        updateScreenWidth()

        window.addEventListener('resize', updateScreenWidth)

        return () => {
            window.removeEventListener('resize', updateScreenWidth)
        }
    }, [screenWidth])

    return (
        <div className={`for-partners__input-block ${isFocused && 'for-partners__input-block_focused'}`}>
            <label htmlFor='message'>ваше сообщение</label>
            <textarea
                style={!isFocused ? { height: 46 } : {}}
                value={isFocused ? messageValue : messageValue.slice(0, letters) + (messageValue.length > letters ? '...' : '')}
                onFocus={() => setIsFocused(true)}
                onBlurCapture={() => setIsFocused(false)}
                onChangeCapture={handleTextareaResize}
                className='for-partners__message-input'
                name='message'
                placeholder='текст'
                {...register('message', { required: true })}
            ></textarea>
        </div>
    )
}

export default ForPartnersMessage
